import { createAsyncThunk } from '@reduxjs/toolkit';
import axiosPixLink from 'config/axiosPixLink';
import axiosPrivate from 'config/axiosPrivate';

export const fetchAdminUserManagement = createAsyncThunk(
  'adminUserManagement/fetchAdminUserManagement',
  async (arg, thunkAPI) => {
    try {
      const response = await axiosPixLink.get('/user/all');
      if (response.status === 200) {
        return response.data;
      }
      return thunkAPI.rejectWithValue(response.status);
    } catch (e) {
      return thunkAPI.rejectWithValue(e.response.data);
    }
  }
);

export const fetchAdminThaiManagement = createAsyncThunk(
  'adminUserManagement/fetchAdminUserManagement',
  async (arg, thunkAPI) => {
    try {
      const response = await axiosPixLink.get('/user/consultants');
      if (response.status === 200) {
        return response.data;
      }
      return thunkAPI.rejectWithValue(response.status);
    } catch (e) {
      return thunkAPI.rejectWithValue(e.response.data);
    }
  }
);
